// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewWedingModal_modalWrp__NjwqV {
  z-index: 2000;
}
.NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalInner__Fjuhl {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 960px;
  max-width: 95%;
  min-height: 600px;
  max-height: 90dvh;
  border-radius: var(--border-radius-large);
  border: unset;
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}
.NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalImage__FPvCn {
  width: 100%;
  height: 100%;
  padding: 30px 46px;
  background: rgba(255, 255, 255, 0.3019607843);
}
.NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalImage__FPvCn:empty {
  display: none;
}
.NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalImage__FPvCn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
}
.NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalBody__CX6JC {
  padding: 24px;
  background-color: var(--bg1);
  min-height: 600px;
  max-height: 80dvh;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.NewWedingModal_modalWrp__NjwqV .NewWedingModal_bgImg__-lqJc {
  position: absolute;
  bottom: -90px;
  right: -70px;
  width: 310px;
  height: 307px;
  z-index: 1;
  opacity: 0.5;
}
@media screen and (max-width: 1170px) {
  .NewWedingModal_modalWrp__NjwqV .NewWedingModal_bgImg__-lqJc {
    bottom: -100px;
    width: 270px;
  }
}
@media screen and (max-width: 599px) {
  .NewWedingModal_modalWrp__NjwqV .NewWedingModal_bgImg__-lqJc {
    bottom: -50px;
    right: -40px;
    width: 180px;
    height: 180px;
  }
}
.NewWedingModal_modalWrp__NjwqV .NewWedingModal_bgImg__-lqJc img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

@media screen and (max-width: 767px) {
  .NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalInner__Fjuhl {
    padding: 0;
    background-color: var(--bg1);
    grid-template-columns: repeat(1, 1fr);
  }
  .NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalImage__FPvCn {
    display: none;
  }
  .NewWedingModal_modalWrp__NjwqV .NewWedingModal_modalBody__CX6JC {
    padding: 16px;
  }
}
.NewWedingModal_welcomeModal__\\+Kmbi {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  position: relative;
  z-index: 2;
  padding: 5px;
}
.NewWedingModal_welcomeModal__\\+Kmbi.NewWedingModal_guestCount__aEn04 {
  align-items: end;
}
.NewWedingModal_welcomeModal__\\+Kmbi.NewWedingModal_modalMainContainer__fiZBQ {
  max-width: 85%;
  margin: 0 auto;
}
@media screen and (max-width: 450px) {
  .NewWedingModal_welcomeModal__\\+Kmbi.NewWedingModal_modalMainContainer__fiZBQ {
    max-width: 100%;
  }
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_welcomeModalBody__Z3ovp {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  width: 100%;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_modalContainer__xfdns {
  max-width: 80%;
  margin: 0 auto;
}
@media screen and (max-width: 450px) {
  .NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_modalContainer__xfdns {
    max-width: 90%;
  }
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_buttonContainer__uqqf8 {
  width: 100%;
  margin-top: 22px;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_buttonContainer__uqqf8.NewWedingModal_buttonContainerCenter__tl0zp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_Budget__5Z-Yd {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_CuratedListHeader__LzB0c {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
@media (max-width: 450px) {
  .NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_CuratedListHeader__LzB0c {
    flex-direction: column;
  }
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_CuratedListBody__7lre8 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 5px;
  padding-top: 20px;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_CuratedListVenueBody__u7XZU {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 5px;
  padding-top: 20px;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_VenuesSelectionImages__qhPSp {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  overflow-x: auto;
  max-width: 100%;
  padding-bottom: 5px;
}
.NewWedingModal_welcomeModal__\\+Kmbi h2 {
  font: var(--h3);
  color: var(--primary-Text);
  text-align: center;
  font-weight: 700;
  font-family: var(--font-bodoni-72);
}
.NewWedingModal_welcomeModal__\\+Kmbi h2 span {
  font-family: var(--font-alex);
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_priceRange__56Bb7 {
  text-align: center;
  margin-bottom: 22px;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_priceRange__56Bb7 input {
  width: 100%;
  max-width: 100%;
}
.NewWedingModal_welcomeModal__\\+Kmbi .NewWedingModal_buttonBox__xxI9T {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.NewWedingModal_uploadCircle__AuRnN {
  width: 120px;
  height: 120px;
  border-radius: 500px;
  border: 2px solid var(--border);
  background-color: var(--white);
  color: var(--secondary-Text);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: relative;
  font: var(--body-font-four);
  margin: 0 auto;
}
.NewWedingModal_uploadCircle__AuRnN span {
  font: var(--body-font-four);
}

.NewWedingModal_cameraIcon__XAWeb {
  position: absolute;
  bottom: 0px;
  right: 0px;
  background-color: var(--brand);
  color: var(--white);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.NewWedingModal_cameraIcon__XAWeb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
  filter: brightness(0) invert(1);
}

.NewWedingModal_formInputs__IahjK {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  justify-content: center;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/onboarding/NewWeddingModal/NewWedingModal.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;AACD;AACC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uDAAA;AACF;AAEC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;AAAF;AAEE;EACC,aAAA;AAAH;AAGE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AADH;AAKC;EACC,aAAA;EACA,4BAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAHF;AAMC;EACC,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;AAJF;AAME;EATD;IAUE,cAAA;IACA,YAAA;EAHD;AACF;AAKE;EAdD;IAeE,aAAA;IACA,YAAA;IACA,YAAA;IACA,aAAA;EAFD;AACF;AAIE;EACC,WAAA;EACA,YAAA;EACA,sBAAA;AAFH;;AAOA;EAEE;IACC,UAAA;IACA,4BAAA;IACA,qCAAA;EALD;EAQA;IACC,aAAA;EAND;EASA;IACC,aAAA;EAPD;AACF;AAWA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AATD;AAWC;EACC,gBAAA;AATF;AAYC;EACC,cAAA;EACA,cAAA;AAVF;AAYE;EAJD;IAKE,eAAA;EATD;AACF;AAYC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAVF;AAaC;EACC,cAAA;EACA,cAAA;AAXF;AAaE;EAJD;IAKE,cAAA;EAVD;AACF;AAaC;EACC,WAAA;EACA,gBAAA;AAXF;AAaE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAXH;AAgBC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAdF;AAmBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAjBF;AAmBE;EAND;IAOE,sBAAA;EAhBD;AACF;AAmBC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAjBF;AAoBC;EACC,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAlBF;AAuBC;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AArBF;AA0BC;EACC,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;AAxBF;AA0BE;EACC,6BAAA;AAxBH;AAoCC;EACC,kBAAA;EACA,mBAAA;AAlCF;AAoCE;EACC,WAAA;EACA,eAAA;AAlCH;AAsCC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AApCF;;AAwCA;EACC,YAAA;EACA,aAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;AArCD;AAuCC;EACC,2BAAA;AArCF;;AAyCA;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtCD;AAwCC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;AAtCF;;AA0CA;EACC,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,SAAA;AAvCD","sourcesContent":[".modalWrp {\r\n\tz-index: 2000;\r\n\r\n\t.modalInner {\r\n\t\tposition: absolute;\r\n\t\ttop: 50%;\r\n\t\tleft: 50%;\r\n\t\ttransform: translate(-50%, -50%);\r\n\t\twidth: 960px;\r\n\t\tmax-width: 95%;\r\n\t\tmin-height: 600px;\r\n\t\tmax-height: 90dvh;\r\n\t\tborder-radius: var(--border-radius-large);\r\n\t\tborder: unset;\r\n\t\toverflow: hidden;\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(auto-fit, minmax(0, 1fr));\r\n\t}\r\n\r\n\t.modalImage {\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tpadding: 30px 46px;\r\n\t\tbackground: #ffffff4d;\r\n\r\n\t\t&:empty {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t\tobject-position: center;\r\n\t\t\tborder-radius: 12px;\r\n\t\t}\r\n\t}\r\n\r\n\t.modalBody {\r\n\t\tpadding: 24px;\r\n\t\tbackground-color: var(--bg1);\r\n\t\tmin-height: 600px;\r\n\t\tmax-height: 80dvh;\r\n\t\theight: 100%;\r\n\t\tposition: relative;\r\n\t\toverflow: hidden;\r\n\t}\r\n\r\n\t.bgImg {\r\n\t\tposition: absolute;\r\n\t\tbottom: -90px;\r\n\t\tright: -70px;\r\n\t\twidth: 310px;\r\n\t\theight: 307px;\r\n\t\tz-index: 1;\r\n\t\topacity: 0.5;\r\n\r\n\t\t@media screen and (max-width: 1170px) {\r\n\t\t\tbottom: -100px;\r\n\t\t\twidth: 270px;\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 599px) {\r\n\t\t\tbottom: -50px;\r\n\t\t\tright: -40px;\r\n\t\t\twidth: 180px;\r\n\t\t\theight: 180px;\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n\t.modalWrp {\r\n\t\t.modalInner {\r\n\t\t\tpadding: 0;\r\n\t\t\tbackground-color: var(--bg1);\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t}\r\n\r\n\t\t.modalImage {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t.modalBody {\r\n\t\t\tpadding: 16px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.welcomeModal {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: center;\r\n\tjustify-content: start;\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\toverflow-y: auto;\r\n\tposition: relative;\r\n\tz-index: 2;\r\n\tpadding: 5px;\r\n\r\n\t&.guestCount {\r\n\t\talign-items: end;\r\n\t}\r\n\r\n\t&.modalMainContainer {\r\n\t\tmax-width: 85%;\r\n\t\tmargin: 0 auto;\r\n\r\n\t\t@media screen and (max-width: 450px) {\r\n\t\t\tmax-width: 100%;\r\n\t\t}\r\n\t}\r\n\r\n\t.welcomeModalBody {\r\n\t\tflex-grow: 1;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tmargin-bottom: 20px;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.modalContainer {\r\n\t\tmax-width: 80%;\r\n\t\tmargin: 0 auto;\r\n\r\n\t\t@media screen and (max-width: 450px) {\r\n\t\t\tmax-width: 90%;\r\n\t\t}\r\n\t}\r\n\r\n\t.buttonContainer {\r\n\t\twidth: 100%;\r\n\t\tmargin-top: 22px;\r\n\r\n\t\t&.buttonContainerCenter {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t// Budget\r\n\t.Budget {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tgap: 6px;\r\n\t}\r\n\r\n\t// Budget\r\n\t// CuratedListHeader\r\n\t.CuratedListHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\twidth: 100%;\r\n\r\n\t\t@media (max-width: 450px) {\r\n\t\t\tflex-direction: column;\r\n\t\t}\r\n\t}\r\n\r\n\t.CuratedListBody {\r\n\t\twidth: 100%;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: start;\r\n\t\tgap: 16px;\r\n\t\toverflow-x: auto;\r\n\t\tpadding-bottom: 5px;\r\n\t\tpadding-top: 20px;\r\n\t}\r\n\r\n\t.CuratedListVenueBody {\r\n\t\twidth: 100%;\r\n\t\tmax-width: 100%;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 16px;\r\n\t\tpadding-bottom: 5px;\r\n\t\tpadding-top: 20px;\r\n\t}\r\n\r\n\t// CuratedListHeader\r\n\t// VenuesSelectionImages\r\n\t.VenuesSelectionImages {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: start;\r\n\t\tgap: 16px;\r\n\t\toverflow-x: auto;\r\n\t\tmax-width: 100%;\r\n\t\tpadding-bottom: 5px;\r\n\t}\r\n\r\n\t// VenuesSelectionImages\r\n\r\n\th2 {\r\n\t\tfont: var(--h3);\r\n\t\tcolor: var(--primary-Text);\r\n\t\ttext-align: center;\r\n\t\tfont-weight: 700;\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\r\n\t\tspan {\r\n\t\t\tfont-family: var(--font-alex);\r\n\t\t}\r\n\t}\r\n\r\n\t// p {\r\n\t//     font: var(--body-font-three);\r\n\t//     color: #5E8AA2;\r\n\t//     text-align: center;\r\n\t//     font-weight: 400;\r\n\t//     margin-bottom: 40px;\r\n\t// }\r\n\r\n\t.priceRange {\r\n\t\ttext-align: center;\r\n\t\tmargin-bottom: 22px;\r\n\r\n\t\tinput {\r\n\t\t\twidth: 100%;\r\n\t\t\tmax-width: 100%;\r\n\t\t}\r\n\t}\r\n\r\n\t.buttonBox {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t\twidth: 100%;\r\n\t}\r\n}\r\n\r\n.uploadCircle {\r\n\twidth: 120px;\r\n\theight: 120px;\r\n\tborder-radius: 500px;\r\n\tborder: 2px solid var(--border);\r\n\tbackground-color: var(--white);\r\n\tcolor: var(--secondary-Text);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\ttext-align: center;\r\n\tcursor: pointer;\r\n\tposition: relative;\r\n\tfont: var(--body-font-four);\r\n\tmargin: 0 auto;\r\n\r\n\tspan {\r\n\t\tfont: var(--body-font-four);\r\n\t}\r\n}\r\n\r\n.cameraIcon {\r\n\tposition: absolute;\r\n\tbottom: 0px;\r\n\tright: 0px;\r\n\tbackground-color: var(--brand);\r\n\tcolor: var(--white);\r\n\tborder-radius: 50%;\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\r\n\timg {\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tobject-fit: contain;\r\n\t\tpadding: 4px;\r\n\t\tfilter: brightness(0) invert(1);\r\n\t}\r\n}\r\n\r\n.formInputs {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(1, 1fr);\r\n\tjustify-content: center;\r\n\tgap: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrp": `NewWedingModal_modalWrp__NjwqV`,
	"modalInner": `NewWedingModal_modalInner__Fjuhl`,
	"modalImage": `NewWedingModal_modalImage__FPvCn`,
	"modalBody": `NewWedingModal_modalBody__CX6JC`,
	"bgImg": `NewWedingModal_bgImg__-lqJc`,
	"welcomeModal": `NewWedingModal_welcomeModal__+Kmbi`,
	"guestCount": `NewWedingModal_guestCount__aEn04`,
	"modalMainContainer": `NewWedingModal_modalMainContainer__fiZBQ`,
	"welcomeModalBody": `NewWedingModal_welcomeModalBody__Z3ovp`,
	"modalContainer": `NewWedingModal_modalContainer__xfdns`,
	"buttonContainer": `NewWedingModal_buttonContainer__uqqf8`,
	"buttonContainerCenter": `NewWedingModal_buttonContainerCenter__tl0zp`,
	"Budget": `NewWedingModal_Budget__5Z-Yd`,
	"CuratedListHeader": `NewWedingModal_CuratedListHeader__LzB0c`,
	"CuratedListBody": `NewWedingModal_CuratedListBody__7lre8`,
	"CuratedListVenueBody": `NewWedingModal_CuratedListVenueBody__u7XZU`,
	"VenuesSelectionImages": `NewWedingModal_VenuesSelectionImages__qhPSp`,
	"priceRange": `NewWedingModal_priceRange__56Bb7`,
	"buttonBox": `NewWedingModal_buttonBox__xxI9T`,
	"uploadCircle": `NewWedingModal_uploadCircle__AuRnN`,
	"cameraIcon": `NewWedingModal_cameraIcon__XAWeb`,
	"formInputs": `NewWedingModal_formInputs__IahjK`
};
export default ___CSS_LOADER_EXPORT___;
